import { ToastMessageService } from './../components/layout/toast-message/toast-message.service';
import { AuthService } from './../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { Provider, StaticProvider } from '@angular/core';
import { ProvidersForApiClient } from '../api-clients/providers-for-api-client';
import { ModalService } from './modal/modal.service';
import { ProvidersForServiceAgent } from '../api-clients/providers-for-service-agent';
import { ZoomApiClient } from '../api-clients/zoom/zoom-api-client';
import { ZoomOrchestratorViewModel } from './zoom/zoom-orchestrator-view-model';
import { WebApiServiceAgent } from '../api-clients/web-api-service-agent';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { OnlineService } from '@nts/std/utility';
import { ResponseCacheService } from '../responses/response-cache.service';
import { ZoomAvailablesFilterPipe } from '../components/zoom/zoom-availables-filter.pipe.ts';
import { ClassConstructor } from '@nts/std/serialization';
import { RoutingService } from '../routing/routing.service';
import { CoreOrchestratorViewModelInterface } from '@nts/std/interfaces';

export class ProvidersForViewModel {

    static staticProvidersForOrchestratorViewModel(
        orchestratorViewModelType: ClassConstructor<CoreOrchestratorViewModelInterface>,
        apiClientType: any,
        modalServiceProvider: ModalService,
        httpClient: HttpClient,
        environmentConfiguration: EnvironmentConfiguration,
        authService: AuthService,
        toastMessageService: ToastMessageService,
        onlineService: OnlineService,
        responseCacheService: ResponseCacheService,
        webApiServiceAgent: WebApiServiceAgent,
        routingService: RoutingService,
        additionalOrchestratorProviders: Provider[] = [],
    ): Provider[] {

        const providers = [
            ...ProvidersForApiClient.staticProvidersForApiClient(
                apiClientType,
                httpClient,
                environmentConfiguration,
                authService,
                onlineService,
                responseCacheService,
                webApiServiceAgent
            ),
            {
                provide: AuthService,
                useValue: authService
            },
            {
                provide: ModalService,
                useValue: modalServiceProvider,
            },
            {
                provide: ToastMessageService,
                useValue: toastMessageService,
            },
            {
                provide: RoutingService,
                useValue: routingService,
            },
        ];

        if (additionalOrchestratorProviders && additionalOrchestratorProviders.length > 0) {
            return [
                ...providers,
                ...additionalOrchestratorProviders,
                {
                    provide: orchestratorViewModelType,
                }
            ];
        } else {
            return [
                ...providers,
                {
                    provide: orchestratorViewModelType,
                }
            ];
        }
    }

    static staticProvidersForZoomOrchestratorViewModel(
        modalService: ModalService,
        httpClient: HttpClient,
        environmentConfiguration: EnvironmentConfiguration,
        authService: AuthService,
        toastMessageService: ToastMessageService,
        onlineService: OnlineService,
        responseCacheService: ResponseCacheService,
        webApiServiceAgent: WebApiServiceAgent
    ): StaticProvider[] {
        return [
            {
                provide: ZoomAvailablesFilterPipe
            },
            {
                provide: ToastMessageService,
                useValue: toastMessageService,
            },
            {
                provide: ZoomOrchestratorViewModel,
                deps: [ZoomApiClient, ModalService, ToastMessageService, ZoomAvailablesFilterPipe]
            },
            {
                provide: ZoomApiClient,
                deps: [WebApiServiceAgent]
            },
            {
                provide: ModalService,
                useValue: modalService,
                deps: []
            },
            ...ProvidersForServiceAgent.allStatic(
                httpClient,
                environmentConfiguration,
                authService,
                onlineService,
                responseCacheService,
                webApiServiceAgent
            )
        ];
    }
}
